"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isUndefined = require('lodash/isUndefined');

var createReducer = require('./reduceComponentFields');

function sum(p, v) {
  return p + v;
}
/**
 * extracts the version for each component price table from the Product.
 * @function getPriceTableSettings
 * @param {Product} product
 * @param {*} tableNames - table names for this product
 * @example
 *
 * const product = {
 *      invitations_table_version: 1,
 * }
 *
 * const tableNames = {
 *      price_table_name: 'invitations_table'
 * }
 *
 * getPriceTableSettings(product, tableNames)
 * // => {
 * //   price_table_name: 'invitations_table'
 * //   price_table_version: 1
 * // }
 */


function getPriceTableSettings(product, tableNames) {
  var priceSettingsForComponent = {};
  Object.keys(tableNames).forEach(function (tableName) {
    var name_of_version_parameter_for_product = tableNames[tableName] + '_version';
    var version = product[name_of_version_parameter_for_product];
    var name_of_version_parameter_for_component = tableName.replace('name', 'version');
    priceSettingsForComponent[tableName] = tableNames[tableName];
    priceSettingsForComponent[name_of_version_parameter_for_component] = version;
  });
  return priceSettingsForComponent;
}

function priceFunctionsReducer(priceFunctions, component, quantity, product, tables, priceSettingsForComponent, productLevelParameters, options) {
  var reducer = createReducer(component, quantity, product, tables, priceSettingsForComponent, productLevelParameters, options);
  return priceFunctions.reduce(reducer, 0);
}
/**
 * get the price of each component in a collection at the TOTAL quantity
 * @function getComponentPrice
 * @param {Component} component
 * @param {Number} quantity
 * @param {Object} priceSettingsForComponent
 * @param {Object} productLevelParameters
 */


function getComponentPrice(component, priceSettingsForComponent, productLevelParameters, priceFunctions, options, product) {
  var type = component.type; // get the lookup tables

  var tables = options.priceTables; // sanity check

  if (isUndefined(priceFunctions)) {
    if (type === 'Component') {
      throw new Error("Expected a an inheritor of Component, not Component itself.\n\nCheck ".concat(product.type, ".prototype.constructors\n\n"));
    }

    throw new Error("componentSettings has no entry for ".concat(type));
  } // pass in the component's quantity


  var quantity = component.quantity; // calculate the price

  return priceFunctionsReducer(priceFunctions, component, quantity, product, tables, priceSettingsForComponent, productLevelParameters, options);
}
/**
 * get the price of each component in a collection at the TOTAL quantity
 * @function getComponentCollectionPrices
 * @param {ComponentCollection} componentCollection
 * @param {Number} quantity
 * @param {Object} priceSettingsForComponent
 * @param {Object} productLevelParameters
 * @returns {Array<Number>}
 */


function getComponentCollectionPrices(componentCollection, quantity, priceSettingsForComponent, productLevelParameters, priceFunctions, options, product) {
  var type = componentCollection.type;

  if (!options.componentSettings[type]) {
    throw new Error("options.componentSettings[".concat(type, "] was not found"));
  }

  var tables = options.priceTables;

  if (isUndefined(priceFunctions)) {
    if (type === 'Component') {
      throw new Error("Expected a an inheritor of Component, not Component itself.\n\nCheck ".concat(product.type, ".prototype.constructors\n\n"));
    }

    throw new Error("componentSettings has no entry for ".concat(type));
  }

  return componentCollection.collection.map(function (component) {
    return priceFunctionsReducer(priceFunctions, component, quantity, product, tables, priceSettingsForComponent, productLevelParameters, options);
  });
}
/**
 * @param {String} params.component - type of component
 * @param {Number} params.subtotal
 * @param {Number} params.splitFee
 * @param {Number} params.quantity
 */


var ComponentPrice = function ComponentPrice() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, ComponentPrice);

  this.component = params.component || '';
  this.subtotal = params.subtotal || 0;
  this.splitFee = params.splitFee || 0;
  this.quantity = params.quantity || 0;
};
/**
 * sums the max price of each compoent collection
 * @function priceCalculator
 * @param {Product} product
 * @param {Object} priceTables
 * @param {Object} composables
 */


function priceCalculator(product, options) {
  var productTableSettings = options.priceTableAssignments[product.type]; // extract some Product parameters the Components need to know

  var productLevelParameters = {
    paper_type: product.paper_type
  };
  var collections = product.collections;

  if (product.product_type === 'Custom Samples') {
    return {
      breakdown: [],
      sum: product.printing_type === 'letterpress' ? 25 : 20
    };
  } // get the max price of each component collection


  var componentPrices = [];
  Object.keys(collections).filter(function (key) {
    return collections[key].quantity > 0;
  }).forEach(function (key) {
    // get all versions of this component
    var componentCollection = collections[key]; // get the lookup tables

    var tableNames = productTableSettings[key];

    if (isUndefined(tableNames)) {
      // console.warn(`options.priceTableAssignments.${key} was undefined`);
      return;
    } // get the price settings from the parent


    var priceSettingsForComponent = getPriceTableSettings(product, tableNames);
    var component_type = new componentCollection.Constructor().type;
    var settings = options.componentSettings[component_type];

    if (!settings) {
      throw new Error("No Pricing Settings Found for Component type ".concat(component_type));
    }

    var collectionFunctions = settings.collection,
        componentFunctions = settings.component;
    var componentCollectionPrice = new ComponentPrice({
      quantity: componentCollection.quantity,
      component: componentCollection.type,
      subtotal: 0
    }); // run collectionFunctions over the Collection

    if (collectionFunctions) {
      // get the total quantity of this component (the sum of all versions' quantities)
      var quantity = componentCollection.quantity; // map over each version

      var prices = getComponentCollectionPrices(componentCollection, quantity, priceSettingsForComponent, productLevelParameters, collectionFunctions, options, product); // and return the max price

      if (prices.length > 0) {
        componentCollectionPrice.subtotal += Math.max.apply(null, prices);
      }
    } // run componentFunctions over each Component


    if (componentFunctions) {
      componentCollection.collection.forEach(function (component) {
        componentCollectionPrice.subtotal += getComponentPrice(component, priceSettingsForComponent, productLevelParameters, componentFunctions, options, product);
      });
    }

    if (Number.isNaN(componentCollectionPrice.subtotal)) {
      debugger;
    }

    componentPrices.push(componentCollectionPrice); // if (Object.prototype.isPrototypeOf.call(LetterpressComponent.prototype, new componentCollection.Constructor())) {
    //     /*
    //      * letterpress components are charged at the same rate per version,
    //      * so we need to sum the price of every version at that version's quantity
    //      */
    //     componentCollection.collection.forEach((component) => {
    //         const subtotal = getComponentPrice(component, priceSettingsForComponent, productLevelParameters, options, product);
    //         const componentCollectionPrice = new ComponentPrice({
    //             quantity: component.quantity,
    //             subtotal,
    //             component: component.type,
    //         });
    //         componentPrices.push(componentCollectionPrice);
    //     });
    // } else {
    //     /*
    //      * digital components are charged at the total quantity + any split fees
    //      */
    //     // get the total quantity of this component (the sum of all versions' quantities)
    //     const quantity = componentCollection.quantity;
    //     const componentSplitFee = options.componentSplitFees[key] || 0;
    //     const componentCollectionPrice = new ComponentPrice({
    //         quantity,
    //         component: componentCollection.type,
    //         splitFee: componentCollection.length > 1 ? componentSplitFee : 0,
    //     });
    //     // map over each version
    //     const prices = getComponentCollectionPrices(componentCollection, quantity, priceSettingsForComponent, productLevelParameters, options, product);
    //     // and return the max price
    //     if (prices.length > 0) {
    //         componentCollectionPrice.subtotal = Math.max.apply(null, prices);
    //     }
    //     componentPrices.push(componentCollectionPrice);
    // }
  }); // sum them

  return {
    breakdown: componentPrices,
    // split_fee: componentPrices.map(comp => comp.splitFee).reduce(sum, 0),
    sum: componentPrices.map(function (comp) {
      return comp.subtotal;
    }).reduce(sum, 0)
  };
}

module.exports = priceCalculator;